import { companyListEN } from 'src/app/modules/company-list/company-list';
import { statisticsEN } from 'src/app/modules/company-list/general-statistics/statitics';
import { docFormationEN } from 'src/app/modules/company-view/doc-formation/doc-formation';
import { expirationStudioEN } from 'src/app/modules/expirations/expiration-list/expiration';
import { IndividualsEN } from 'src/app/modules/individuals/individuals';
import { ShareInfoTableEN } from 'src/app/modules/information-shared/information-shared.model';
import { PowersEN } from 'src/app/modules/powers-upload/powers-upload';
import { ActionTypeChileEN, ActionTypeEN, CountriesEn, DocumentTypeEn, ExpirationRangeEn, ExpirationTypeEn, POAStausEn, POATypeEn, PowerTypeEn, RolePersonEn, ShareInfoEn, TratamientEN, UserTypeEn } from 'src/app/modules/shared/combos-lang';
import { userMenuEN } from 'src/app/pages/layout/navbar/models/profile-options';

export const English = {
  lang: 'EN',
  data: {
    INDV: IndividualsEN,
    USER_MENU: userMenuEN,
    COUNTRIES: CountriesEn,
    EXPIRATIONRANGE: ExpirationRangeEn,
    EXPIRATIONTYPE: ExpirationTypeEn,
    POASTATUS: POAStausEn,
    POATYPE: POATypeEn,
    SHAREINFO: ShareInfoEn,
    ROLEPERSON: RolePersonEn,
    DOCUMENTTYPE: DocumentTypeEn,
    USERTYPE: UserTypeEn,
    POWERTYPE: PowerTypeEn,
    POWERS: PowersEN,
    STATS: statisticsEN,
    TRATAMIENTO: TratamientEN,
    ACTIONTYPE: ActionTypeEN,
    ACTIONTYPECHILE: ActionTypeChileEN,
    TITLES: {
      COMPANIES: 'Companies',
      FOLLOWERS: 'Followers',
      ORIGIN_COUNTRY: 'Country of origin',
      SHARE_INFO: 'Share Information',
      LIBRARY: 'Library',
      EXPIRATIONS: 'Expirations',
      USERS: 'Users',
      LOGS: 'Logs list',
      PERSONS: 'Persons',
      PROFILE: 'Profile',
      SOC_ADMIN: 'Societies Administration',
      MY_GROUPS: 'My Groups',
      GROUP: 'Group',
      COMITES: 'Committees',
    },
    CAPITAL: {
      SOCIAL: 'Capital stock',
      SUBS: 'Suscribed capital stock',
      NOM_VALUE: 'Nominal value',
      NOM_VALUE_TODAY: 'Current nominal value',
      SHARES: 'Shares',
      SOCIAL_Q: 'Social quotas',
      TOTAL_CAPITAL_STOCK: 'Total capital stock',
      FIXED_CAP: 'Fixed capital stock',
      VARIABLE: 'Variable capital stock',
      INT: 'Integrated capital stock',
      CURRENCY_TYPE: 'Currency type',
      OVERVIEW: "Overview",
      AUTHORIZED: 'Authorized Capital',
      INTEGRATED: 'Integrated Capital',
      PARTICIPATION: 'Participation',
    },
    TABS: {
      GENERAL_INFO: "General information",
      EXPIRATIONS: "Expirations",
      POWERS: "POAs",
      POWERS_MX: "POAs",
      STATUTE: "Bylaws",
      STATUTES: "Bylaws",
      DOCS: "Formation documents",
      MAP: "Corporate Map",
      BALANCES: "Balances",
      CONTRATOS: "Contracts",
      SHAREHOLDERS: "Shareholders and capital stock",
      PARTNERS: "Partners and capital stock",
      MEMBERS: "Members",
      SUBJECTS: "Subjects",
      AUTHORITIES: "Authorities",
      DIRECTORY_REP: "Directory and Legal Representatives",
      DIRECTORY: "Directory",
      MANAGMENT: "Managment",
      ADMIN_REP: "Administration and Legal Representatives",
      ASSETS_PROVIDED: "Assets provided",
      MINUTES: 'Minutes',
      COMITES: "Committees",
    },
    LINKED_INDEX: {
      TITLE: 'Linked Documents Index',
      TOOLTIP: 'Linked Documents Index',
      CLOSE: 'Close',
      LOADING: 'Loading documents…',
      DOCUMENTS: 'documents',
      NO_DOCUMENTS: 'no documents',
      SEARCH_PLACEHOLDER: 'Search document…',
      EMPTY_TITLE: 'This company has no linked documents',
      EMPTY_SUBTITLE: 'Documents show up here once they are linked from each tab.',
      NO_RESULTS: 'No documents found',
      VIEW: 'View',
      DOWNLOAD: 'Download',
      GO_TO_TAB: 'Go to tab',
      OF: 'of',
      VIEW_ALL: 'View all in the {{tab}} tab',
      ROLE_HINT: 'You can view and download only what your role allows in each module.',
    },
    UBICATION: {
      POSTAL_CODE: 'Postal code',
      JURISDICTION: 'Jurisdiction',
      COUNTRY: 'Country',
      FLOOR: 'Floor',
      OFFICE_NUMBER: 'Office number',
    },
    WIZARD: {
      DURATION_EXCERCISE: 'Duration and excercise',
      DURATION_TERM: 'Term of duration',
      DURATION_TERM_COMPANY: 'Term of duration',
      YEAR_CLOSING: 'Year-end closing',
      ADDRESS: 'Address',
      BYLAW: 'Bylaw',
      BYLAWS: 'Bylaws',
      BYLAW_MX: 'Bylaw',
      CAPITAL_STOCK: 'Capital stock',
      AMOUNT_SHARE: 'Amount of shares',
      TYPE_SHARE: 'Type of shares',
      NOMINAL_VALUE: 'Nominal value',
      OBJECT: 'Corporate purpose',
      MAX_AMOUNT: 'Maximum amount',
      MIN_AMOUNT: 'Minimum amount',
      INDEF_TERM: 'Indefinite term',
      SUB_CAPITAL_STOCK: 'Suscribed capital stock',
      INT_CAPITAL_STOCK: 'Integrated capital stock',
      CAP_STOCK_AND_SHARES: 'Capital stock and shares',
      ADDRESS_AND_HEAD: 'Address and headquarters',
      ADDRESS_2: 'Street',
      DOOR: 'Door number',
      APARTMENT: 'Apartment number',
      HEADQUARTERS: 'Headquarters',
      HEAD_MUST_BE: 'Headquarters must be within the address',
      OFFICE_TERM: 'Term of office',
      DIRECTORY: 'Directory',
      MANAGERS: 'Managers',
      ADMIN: 'Administration',
      NO_INFO: 'No Information',
      AMOUNT_DIRECTORS: 'Amount of Incumbent Directors',
      DIRECTORS_SUP: 'Alternate Directors',
      DIRECTORS_TIT: 'Incumbent Directors',
      MANAGERS_SUP: 'Alternate Managers',
      MANAGERS_TIT: 'Incumbent Managers',
      ADMINS_TIT: "Incumbent Administrators",
      ADMINS_SUP: "Alternate Administrators",
      AUTHORITIES_TIT: "Incumbent Authorities",
      AUTHORITIES_SUP: "Alternate Authorities",
      AMOUNT_DIRECTORS_SUP: 'Amount of Alternate Directors',
      SOCIAL_QUOTAS: 'Social quotas',
      INDET_MANAGERS_TIT: 'Undetermined number of incumbent managers',
      INDET_MANAGERS_SUP: 'Undetermined number of alternate managers',
      PUBLIC_REGISTRY: 'Public registry registration number',
    },
    LABELS: {
      DOC_DETAILS: 'Documents details',
      DOC_SHARE: 'Share document',
      SHARE_TO: 'Shared to',
      ACTIVE: 'Actives',
      INACTIVE: 'Inactives',
      ALL: 'All',
      RENAME: 'Rename',
      AMOUNT_SHARE: "Shares",
      SELECT_FOLDER: 'Select Folder',
      FOLDER_NAME: "Folder name",
      COMPANY_NAME: "Company name",
      COMPANY_TYPE: "Company type",
      CORPORATE_DATA_CONTROL: "Corporate Data Control",
      DOC_TYPE: "Document type",
      DOC_NAME: "Document name",
      DOC_DATE: "Document date",
      DOC_CONTENT: 'Document Content',
      PROCEDURE_TYPE: "Procedure type",
      PROCESS_NUM: "Process number",
      SELECT_DOCS: "Select Document(s)",
      SELECT_DOC: "Select Document",
      SELECT_PROCEDURES: "Seleccione un tipo de trámite",
      STATUS: 'Status',
      VERIFICATION_STATUS: "Verification Status",
      VERIFIED: "Verified",
      VERIFIED_BY: "Verified by",
      NOT_VERIFY: "Not verified",
      NOTVERIFIED: "Not Verified",
      VERIFY: "Verified",
      LAST_VERIFICATION: "Last verification",
      LAST_MODIFICATION: "Last modification",
      MODIFIED_BY: "Modified by",
      PREVIEW: "Preview",
      LOADING: "Loading",
      COMPANIES: "Companies",
      COMPANY: "Company",
      CONVERT_TO: "Convert to Company",
      VIEW: "View detail",
      EDIT: "Edit",
      DELETE: "Delete",
      SELECT: "Select",
      USER: "User",
      DOCUMENT_TYPE: "Document Type",
      NAME: "Name",
      LAST_NAME: "Last name",
      PHONE: "Phone number",
      EMAIL: "Email",
      ACTIONS: "Actions",
      FOLDER: "Folder",
      CREATE: "Create",
      EXPIRATION_DATE: "Expiration date",
      APPROVAL_DATE: "Date of approval",
      FILING_DATE: "Filing date",
      EXPIRATION_TYPE: "Expiration type",
      EXPIRATION_STATUS: "Expiration status",
      EXPIRATION: "Expiration",
      EXPIRATION_DOWNLOAD: 'Download expirations',
      AUTHORITY: "Authority",
      DIRECTOR: "Director",
      DIRECTORS: "Directors",
      MANAGER: "Manager",
      MANAGERS: "Managers",
      ADMIN: "Administrator",
      ADMINS: "Administrators",
      PRESIDENT: "President",
      VICEPRESIDENT: "Vice President",
      MANAGER_TIT: "Incumbent Manager",
      MANAGER_SUP: "Alternate Manager",
      ADMIN_TIT: "Incumbent Administrator",
      ADMIN_SUP: "Alternate Administrator",
      DIR_TIT: "Incumbent Director",
      DIR_SUP: "Alternate Director",
      SIND_TIT: "Titular syndic",
      SIND_SUP: "Alternate syndic",
      REP_LEG_TIT: "Incumbent legal representative",
      REP_LEG_SUP: "Alternate legal representative",
      SUBJECT: "Subject",
      SUBJECTS: "Subjects",
      MEMBERS: "Members",
      MEMBER: "Member",
      TRUSTEE: "Trustee",
      FIDUCIARY: "Fiduciary",
      OR_BENEF: "Original Beneficiary",
      OR_TRUST: "Original Trustor",
      ADHE_BENE: "Adherent Beneficiary",
      ADHE_TRUS: "Adherent Trustor",
      GENERAL_MANAGER: "General Manager",
      SPEC_MANAGER: "Special Manager",
      ALT_MANAGER: "Alternate Manager",
      COMMISSARY: "Commissary",
      ADMINISTRATOR: "Administrator",
      INDEPENDENT_COUNSELOR: "Independent Counselor",
      PATRIMONY_COUNSELOR: "Patrimony Counselor",
      COUNSELOR: "Counselor",
      BOARD_SECRETARY: "Board Secretary",
      NON_MEMBER_SECRETARY: "Non member Secretary",
      VOWEL: "Vowel",
      SECRETARY: "Secretary",
      TREASURER: "Treasurer",
      ADDNEW: '--ADD NEW--',
      NEWAUTH: 'Name new authority',
      TITULAR: "Incumbent",
      SUPLENTE: "Alternate",
      SUPLENTES: "Alternates",
      ADVISER: "Adviser",
      DENOMINATION: "Denomination",
      PERSON: "Person",
      INDIVIDUALS: "Individuals",
      LEGAL_ENTITIES: "Legal entities",
      BIRTH: "Date of birth",
      NATIONALITY: "Nacionality",
      OCCUPATION: "Occupation",
      MARITAL_STATUS: "Marital status",
      TITLE: "Title",
      ID_TYPE: "ID type",
      ID_NUMBER: "ID type",
      PERSONAL_INFO: "Personal information",
      ADDITIONAL_INFO: "Additional document",
      ID_COPY: {
        AR: 'Copy of ID card/Passport',
        CL: 'Copy of ID card/Passport',
        PY: 'Copy of ID card/Passport',
        UY: 'Copy of ID card/Passport',
        US: 'Copy of ID card/Passport',
        MX: 'Copy of ID card/Passport',
        DF: 'Copy of ID card/Passport',
      },
      NEW: "new",
      OF: "of",
      SHAREHOLDERS: "Shareholders",
      SHAREHOLDER: "Shareholder",
      PARTNERS: "Partners",
      PARTNER: "Partner",
      LEGAL_REPRESENTATIVE: "Legal representative",
      LEGAL_REPRESENTATIVES: "Legal representatives",
      DOCUMENT: "Document",
      OPERATION_COUNTRIES: "Countries of operation",
      OPERATION_COUNTRY: "Country of operation",
      NO_OPERATION_COUNTRIES: "This Company has no Countries of Operation",
      NOT_APPLICABLE: "Not Applicable",
      NO_STATUS: "No Status",
      NO_TYPE: "No Type",
      ATTACH_MAP: "Attach corporate map",
      ATTACH_MAP_CL: "Attach corporate map",
      INFORMATION: "Information",
      NB_PUBLIC_REGISTRY: "Public registry registration number",
      NB_TAX_ID: "Tax identification number",
      NB_TAX_ID_SHORT: "Tax identification number",
      ART_REGISTRATION: "Registration article",
      INFO_REGISTRATION_YEAR: "Registration article",
      CHOOSE_LINK: "Choose the document you want to link",
      LINKED_DOCS_TITLE: "Linked documents",
      ADD_FROM_LIBRARY: "Add from library",
      LINK_LIBRARY_HINT: "Find a PDF in the library and link it to this record.",
      SEARCH_LIBRARY_PLACEHOLDER: "Search the library…",
      LINKING_AUTO_UPDATE: "When you link or unlink, the record updates automatically.",
      NO_LINKED_CTA: "Add one from the library below.",
      OPEN_IN_NEW_TAB: "Open in new tab",
      UPLOAD_NEW_FILE: "Upload new file",
      UPLOAD_CONSTRAINTS_HINT:
        'Supported formats: {{formats}}. Maximum size per upload: {{limit}}.',
      UPLOAD_FOLDER_EMPTY_HINT:
        'Subfolders are uploaded keeping their structure. Empty subfolders are not created: if you need them, add them from the Library.',
      UPLOAD_NEW_POA: "Upload new POA",
      DETAIL_POA: "POA Details",
      SHARES: "Shares",
      SHARES_TYPES: 'Types of shares',
      SHARES_CLASSES: 'Classes of shares',
      QUOTAS: "Quotas",
      TOTALS: "Totals",
      GENDER: "The",
      QUESTION_ADD: "The authority you want to add is a",
      QUESTION_ADD_PERSON: '¿The person you want to add is',
      QUESTION_ADD_LEGAL: 'Is the authority you want to add a <b>Legal entity</b>?',
      LEGAL_ENTITY: "Legal entity",
      SELECT_NEW: "Select new authority",
      ADD_NEW: "Add new",
      PERCENTAJE: "Percentaje",
      CAPITAL: "Capital",
      FIXED_CAP: "Fixed capital stock",
      VARIABLE_CAP: "Variable capital stock",
      TOTAL_CAPITAL_STOCK: "Total Capital Stock",
      PROFESSIONAL: "Professional in charge",
      CONTROL_BODIES: "Control bodies",
      ACTIVITY: "Activity",
      ACTIVITY_SII: "Activity and SII Code",
      SELECT_ACTIVITY: "Select activities",
      SELECT_CONTROL: "Select control bodies",
      DATE_INCORPORATION: "Date of incorporation",
      PAGES: "Pages",
      NUMBER: "Number",
      YEAR: "Year",
      SELECT_YEAR: "Select year",
      REAL_STATE_CONSERVATIVE: "Real State Conservative",
      PUBLICATION_EXTRACT:
        "Publication of extract of incorporation in the official gazette",
      SUPERVISOR_BODY: "Supervisory body",
      FANTASY_NAME: "Fantasy name",
      COMMERCIAL_NUMBER: "Commercial Registry Registration Number",
      INS_NUM_BANCO_CENTRAL_UY: "Banco Central de Uruguay Registration Number",
      INS_NUM_BANCO_PREV_UY: "Banco de Previsión Social Registration Number",
      DATE_BANCO_CENTRAL_UY: "Banco Central de Uruguay Registration Date",
      BOOK_CUSTODY: "Book custody",
      DENOMINATION_NAME: "Company name",
      PUBLIC_REGISTRY: "Public registry",
      SAT_ACTIVITY: "SAT Activity",
      IMSS: "IMSS Employer Registration",
      OWNERSHIP_PERCENTAJE: "Ownership percentage",
      AMOUNT_SHARES: "Amount of shares",
      ELEVATION_NUMBER: "Script number",
      POA_NAME: "Name of the POA",
      GRANT_DATE: "Grant date",
      PROXIES_NAME: "Proxies",
      POWERS_CONFERRED: "Powers conferred",
      PAID: "Paid",
      FIXED_PORTION: "Fixed portion",
      VARIABLE_PORTION: "Variable portion",
      AMOUNT_SOCIAL: "Amount of social quotas",
      NAME_LASTNAME: "Name and Last name",
      POSITION: "Position",
      TERM_EXPIRATION: "Term expiration",
      DESIGNATION_DATE: 'Desgination date',
      COUNTRY: "Country",
      REPRESENTATIVE: "Representative",
      APPOINTMENT_DATE: "Appointment date",
      POWER: "POA",
      POA_DETAILS: "POA details",
      POA_TYPE: "POA type",
      POA_INFORMATION: "POA Information",
      GENERAL_POA: "General POA",
      TYPE_GENERAL_POA: "General POA type",
      SPECIAL_POA: "Special POA",
      TYPE_SPECIAL_POA: "Special POA type",
      APPOINT_PROXIES: "Appoint Proxies",
      SELECT_PROXIES: "Select Proxy",
      LIST_PROXIES: "List of proxies",
      SELECT_POWER: "Select power",
      LIST_POWERS: "List of powers",
      NOTARY_REG_NUM: "Notary registration number",
      FOLIO_NUMBER: "Sheet",
      FOLIO: "Sheet",
      NOTARY_REG: "Not. Reg.",
      NOTARY_NAME: "Notary name",
      NOTARY_PERSON: "Notary name (person)",
      OBSERVATIONS: "Observations",
      NO_OBSERVATIONS: 'No observations',
      FOLIO_NUM: "Sheet",
      NOTARY_REG_NUMB: "Notary registration number",
      REPERTOIRE_NUMBER: "Repertoire number",
      DEED_NUM: "Deed number",
      DEED_NUMBER: "Deed number",
      DEED_NMB: "Deed Num.",
      DEED_DATE: "Deed date",
      NOTARY_NUMBER: "Notary number",
      POWERS: "Powers",
      LAST_DATE_REGIME: "Last date of compliance with the Information Regime",
      TAX_ID_NUM: "Tax identification number",
      AMOUNT_OF: "Amount of",
      BALANCE: "Balance",
      APPROVAL: "Approval",
      FILING: "Filing",
      CONTRACT: "Contract",
      CONTRACT_TYPE: "Contract type",
      OPEN_FIELD: 'Free text',
      ASSET_NAME: "Name of the asset",
      ASSET: "Asset",
      VIEW_NAME: "View name",
      ROLE: "Role",
      EDIT_INFORMATION: "Edit Information",
      PURPOSE: 'Company purpose',
      REGISTERED_OFFICE: 'Registered office',
      INF_ART_INCORPORATION: 'Information on the articles of incorporation',
      USERNAME: 'Username',
      ENTRY_DATE: 'Entry date',
      USER_TYPE: 'User type',
      INITIALS: 'Initials',
      SHARE_INFORMATION: 'Share Information',
      SIGN: 'Signatory',
      EDITOR: 'Editor',
      CLIENTE: 'Customer',
      READ_ONLY: 'Read Only',
      SECURITY: 'Security',
      LOGS: 'Logs',
      CLICKORDER: 'Click to order',
      AVAILABLE_CAPITAL: 'Remaining',
      NEW_CLASS: 'New Class',
      UNDEFINED: 'Undefined',
      FOLIO_MER:'Commercial registry file number',
      FIRMA_LIM: 'Signature and Limits',
      SIGNATURE: 'Signature',
      LIMITS: 'Limits',
      CLASS: 'Class',
      NAME_GROUP: 'Group name',
      SHARED_SOC: 'Shared Societies',
      SHOWMORE: 'Show more',
      SHOWLESS: 'Show less',
      SEE_X_MORE: 'See {{count}} more',
      SEE_LESS: 'See less',
      MINUTES_NUMBER: 'Minutes Number',
      MINUTES_DATE: 'Minutes Date',
      ATTACH_INFO: 'Download Additional Information',
      ATTACH_INFO_AD: 'Attach Additional Information',
      CAPITAL_AUTHORIZED: 'Capital Authorized',
      CAPITAL_INTEGRATED: 'Capital Integrated',
      VOTE_VALUE: 'Votes per share',
      MINUTES: 'Minutes',
      MINUTES_TYPE: 'Minutes type',
      RESOLUTION: 'Resolution',
      BOOK: 'Book',
      REGISTRY_FILE: 'Registry file',
      TYPE_POWER: 'Type of power',
      MEMBERS_COMITE: 'Committee members',
      COMITE_NAME: 'Committee name',
      COPY_TO_BOOK: 'Copy to book',
      SIGNATURES: 'Signatures',
      SIGN_ALL: 'Sign all',
    },
    OPTIONS: {
      LAW_COL: 'Lawsuits and collections',
      ADMIN_ACTS: 'Acts of Administration',
      ADMIN_ACTS_LAB: 'Acts of administration in labor matters',
      PROP_ACTS: 'Property Acts',
      MODEL: 'Template',
    },
    MESSAGES: {
      PREVIEW_NOT_FOUND: 'Preview not found',
      SUCCESS_MAP: 'Additional information updated successfully',
      ERROR_MAP: 'An error occurred while updating the Corporate map',
      DELETE_QUESTION: 'Are you sure you want to delete',
      UNLINK_QUESTION: 'Are you sure you want to unlink',
      INACTIVE_QUESTION: 'Are you sure you want to deactivate the company? You will be able to activate it again whenever you choose to.',
      ACTIVE_QUESTION: 'Are you sure you want to activate the company?',
      DELETE_COMP_QUESTION: 'Are you sure you want to delete the selected company?',
      REMEMBER_DOC:
        'Remember to upload the document that supports this change to the library',
      SUCCESS_UPDATE: 'It has been updated successfully',
      ERROR_UPDATE: 'An error occurred while updating',
      ERROR_INVALID: 'it is an unsupported type of file',
      UPLOAD_INVALID_FORMAT:
        'Cannot be uploaded due to unsupported format: {{files}}. Supported formats: {{formats}}.',
      UPLOAD_AND_N_MORE: 'and {{count}} more',
      UPLOAD_SIZE_EXCEEDED:
        'The upload exceeds the maximum size per upload. Limit: {{limit}}. Selected size: {{size}}. Remove files or upload the folder in parts.',
      UPLOAD_BLOCKED_SIZE_TITLE_FOLDER: 'This folder cannot be uploaded',
      UPLOAD_BLOCKED_SIZE_BODY_FOLDER:
        'The selected folder is {{size}} and exceeds the {{limit}} maximum per upload. Upload it in parts or remove files to continue.',
      UPLOAD_BLOCKED_SIZE_TITLE_FILES: 'These documents cannot be uploaded',
      UPLOAD_BLOCKED_SIZE_BODY_FILES:
        'Your selection is {{size}} and exceeds the {{limit}} maximum per upload. Upload it in batches or remove documents to continue.',
      MUST_SELECT_PROXY: 'You must select at least one Proxy',
      MUST_SELECT_POWER: 'You must select at least one POA',
      POA_SAVED_SUCCESS: 'POA successfully generated.',
      POA_SAVED_DOC_LINKED: 'POA successfully generated and document linked.',
      POA_SAVED_DOC_NOT_LINKED: 'POA successfully generated, document not linked.',
      POA_CLONED_SUCCESS: 'POA successfully cloned.',
      DELETE_POA_QUESTION: 'Are you sure you want to delete the POA?',
      DELETE_POA_DESCRIPTION: 'Remember to upload to the Library the document that backs this modification.',
      BALANCE_DELETED_SUCCESS: 'Balance successfully deleted.',
      EXPIRATION_GENERATED: 'Expiration successfully generated.',
      EXPIRATION_DELETED: 'Expiration successfully deleted.',
      COMPANY_DELETED: 'Company successfully deleted.',
      EDIT_CONTRACT: 'Edit contract',
      ADD_CONTRACT: 'Add new contract',
      EDIT_ASSET: 'Edit asset',
      ADD_ASSET: 'Add new asset',
      EDIT_BALANCE: 'Edit balance',
      ADD_BALANCE: 'Add new balance',
      DELETE_CONTRACT: 'Are you sure you want to delete this contract?',
      USER_ADMIN: 'Addressed to the account owner. Has access to everything including user administration and payments.',
      USER_SIGN: 'Can edit information and initiate documents and approve them, but cannot add new users.',
      USER_EDIT: 'Can edit information and start documents, but cannot approve them or add new users.',
      USER_READ_ONLY: 'Can only read information.',
      USER_CLIENT: 'View all shared company information and documents.',
      USER_IT: 'Exclusive access to the security module. Can manage users and administer groups, but cannot access company information.',
      USER_LOGS: 'Exclusive access to the Logs module. Can review the activity log, but cannot access company information.',
      OK_DOC: "Document updated successfully",
      ERR_DOC: "An error occurred while updating document",
      ERR_GENERIC: "An error occurred. Please contact the administrator",
      ERR_FOLDER: "You cannot delete folders that contain documents inside",
      EDIT_MINUTES: 'Edit minutes',
      ADD_MINUTES: 'Add new minutes',
      DELETE_MINUTES: 'Are you sure you want to delete the minutes?',
      EDIT_COMITE: 'Edit committee',
      ADD_COMITE: 'Add new committee',
      NO_LINKED_FILES: 'No linked documents',
      DOWNLOAD_TO_VIEW: 'Download the file to view it',
      ADMIN_DESCRIPTION: 'Create groups to manage user access to companies. Each group defines which companies its members can view and manage.',
      USERS_DESCRIPTION: 'Manage platform users. Create new accesses, edit information, and administer each user\'s roles.',
      NO_DOC_TYPES: 'No document types available for this company',
      NEED_PRESIDENT: 'To approve a document, the company must have a president.',
      PRESS_HASH: 'Press # to see available variables',
      UNUSED_VARS: 'The following variables are not being used:',
      SAVE_AS_MODEL: 'Will be saved as default template',
      SAVE_DOC_ONLY: 'Will be saved for this document only',
    },
    BUTTONS: {
      COPY: 'Copy',
      SHARE_FOLDER: 'Share folder',
      SHARE_DOC: 'Share document',
      CLEAN_FILTER: 'Remove Filters',
      OPEN: 'Open',
      FILTER: 'Filter',
      FILTERS: 'Filters',
      UPDATE: 'Update',
      GO_TO_LIBRARY: 'Go to library',
      CORPORATE_SUMMARY: 'Coporate summary',
      VERIFY: 'Verify',
      SHARE: 'Share',
      ATTACH_DOCS: 'Attach documents',
      SEE_ATTACH_DOCS: 'View Linked Documents',
      SAVE: 'Save',
      MODIFY: 'Modify',
      NEXT: 'Next',
      PREVIOUS: 'Previous',
      CHANGE_COUNTRY: 'Change Country',
      CLOSE: 'Close',
      APPROVE: 'Approval of',
      FINALIZE: 'Finalize process',
      EDIT_DOC: 'Edit document',
      SAVE_PRINT: 'Save & print draft',
      SAVE_DRAFT: 'Save Draft',
      NEW: 'New',
      NUEVA: 'New',
      DOC: 'Document',
      DOCS: 'Documents',
      BY_DOC_NAME: 'By document name',
      BY_FOLDER_NAME: 'By folder name',
      BY_CONTENT: 'By document contents',
      UPLOAD: 'Upload',
      DELETE: 'Delete',
      DELETE_SELECTED: 'Delete selected items',
      MOVE_SELECTED: 'Move selected items',
      DOWNLOAD: 'Download',
      DOWNLOAD_REPORTS: 'Download Reports',
      MOVE_TO: 'Move to',
      MOVE_FOLDER_TO: 'Move to…',
      ADD: 'Add',
      ALL: 'All',
      CANCEL: 'Cancel',
      RESOLVED: 'Resolved',
      BACK: 'Back',
      WHY_Q: '¿Why?',
      LINKAGES: 'Linkages',
      FULL_VIEW: 'Full View',
      LOCAL_VIEW: 'Local View',
      SAVE_VIEW: 'Save View',
      SEE: 'See Company',
      LINK_FILE: 'Link File',
      UNLINK: 'Unlink',
      SEE_FILE: 'See File',
      ADD_REP_LEG: 'Add Incumbent legal',
      UPDATE_SHAREHOLDER: 'Update shareholder',
      EDIT: 'Edit',
      EDIT_POWER: 'Edit POA',
      ENTER: 'View POA',
      EDIT_PARTNER: 'Edit Partner',
      LINK_FILES: 'Link files',
      GO_TO_UBICATION: 'Go to file ubication',
      SAVE_CHANGES: 'Save changes',
      CREATE_GROUP: 'Create Groups',
      CLONE: 'Clone',
      CLEAR_DATES: 'Clear dates',
    },
    PLACEHOLDERS: {
      SEARCH: 'Search',
      USERS: 'Users',
      SEARCH_USER: 'Search user',
      SEARCH_COMPANY: 'Search company',
      SEARCH_BY_NAME: 'Search by Name',
      SEARCH_BY_LAST_NAME: 'Search by lastname',
      FROM: 'From',
      TO: 'To',
    },
    STATUTE: {
      DIRECTORY: 'Directory',
      TERM_YEAR: 'Term of existence and fiscal year',
      TERM_COMPANY: 'Term of existence of the company',
      YEAR_CLOSE: 'Year-end closing',
      COMPANY_EXPIRATION_DATE: 'Expiration date of the companys',
      AUTHORITIES: 'Authorities',
      INCUMBENT_DIR: 'Incumbent Directors',
      SUP_DIR: 'Alternate Directors',
      MAX_Q: 'Maximum amount',
      MIN_Q: 'Minimum amount',
      TERM_OFFICE: 'Term of office',
      OBJ: 'Legal purpose',
      OPEN_FIELD: 'Open field',
      NUM_DIC: 'Amount of Directors',
      IND_TERM: 'Indefinite term',
      UNDET_NUM: "Undetermined number of"
    },
    COMPANY_LIST: companyListEN,
    SHARE_INFO_TABLE: ShareInfoTableEN,
    DOC_FORMATION_TABLE: docFormationEN,
    EXP_STUDIO_TABLE: expirationStudioEN,
    IND: {
      NAME_LASTNAME: 'Fullname',
      AUTHORITY: 'Authority',
      STOCK: 'Shareholder',
      POWER: 'Proxies',
      FULL_REPO: 'Full report',
      SHAREHOLDERS_REPO: 'Shareholders Report',
      FINAL_REPO: 'Final Beneficiary Report',
      ASK_TYPE_DOC: '¿Que informacion desea descargar?'
    },
    MENU: {
      LIBRARY: 'Library',
      CONTRACTS: 'Contracts',
      DOCUMENTS: 'Documents',
      PERSONS: 'Persons',
      COMPANIES: 'Companies',
      EXPIRATIONS: 'Expirations',
      TRAMITES: 'Registration procedures',
      SHAREINFO: 'Share Information',
      ADD: 'Create Company',
      CORPOTATE_MAP: 'Corporate map',
      ADMINISTRATION: 'Administration',
      SECTION_PRINCIPAL: 'Main',
      SECTION_MANAGEMENT: 'Management',
      SECTION_SECURITY: 'Security',
      SECTION_LOGS: 'Logs',
      USERS: 'Users',
      LOGS: 'Logs',
    },
    CONTRACTS: {
      TITLE: 'Contracts',
      SEARCH_PLACEHOLDER: 'Search contract, counterparty or object — Enter',
      SEARCH_HINT: 'Type and press Enter to search',
      CLEAR_SEARCH: 'Clear search',
      SEARCH_EMPTY: 'No contracts found for “{{term}}”.',
      LOAD_NEW: 'Load New Contract',
      ALERTS: 'Alerts',
      FILTER_EXPIRATIONS: 'Expirations',
      ALERT_HAS: 'With alerts',
      ALERT_30: 'Expires in 30 days',
      ALERT_60: 'Expires in 60 days',
      COL_CONTRACT: 'Contract',
      COL_TYPE: 'Type',
      COL_SOCIETY: 'Society',
      COL_COUNTERPARTY: 'Counterparty',
      COL_PARTIES: 'Parties',
      COL_OBJECT: 'Object',
      COL_MONTO: 'Amount',
      MONTO_MODIFIED_BADGE: 'Addendum',
      MONTO_MODIFIED_TOOLTIP: 'Modified by addendum. Previously: {{previous}}',
      COL_NEXT_EXPIRATIONS: 'Next expirations',
      COL_AUTO_RENEWAL: 'Auto renewal',
      COL_STATUS: 'Status',
      COL_TAGS: 'Tags',
      STATUS_ACTIVE: 'Active',
      STATUS_EXPIRING: 'Expiring',
      STATUS_EXPIRED: 'Expired',
      VIEW: 'View',
      YES: 'Yes',
      NO: 'No',
      VIEW_MODE: 'View',
      VIEW_LIST: 'Flat',
      VIEW_GROUPED: 'Grouped by framework',
      FRAMEWORK: 'Framework',
      NO_FRAMEWORK: 'Contracts without framework',
      OF_FRAMEWORK: 'of',
      GROUPED_EMPTY: 'No contracts to show with the applied filters.',
      FLAT_EMPTY: 'No contracts to show with the applied filters.',
      RESULTS_COUNT: '{{count}} contracts',
      GROUPS_COUNT: '{{count}} groups',
      MARCOS_CONTRACTS_COUNT: '{{marcos}} frameworks · {{contracts}} contracts',
      DELETE: {
        CONFIRM_TITLE: 'Delete contract?',
        IMPACT_INTRO: 'Deleting this contract will also cascade-delete:',
        IMPACT_OUTRO: 'This action cannot be undone.',
        SIMPLE: 'This action cannot be undone.',
        AND: 'and',
        N_SUBCONTRACT: 'subcontract',
        N_SUBCONTRACTS: 'subcontracts',
        N_ADDENDA: 'addendum',
        N_ADDENDAS: 'addenda',
        N_EXPIRATION: 'expiration',
        N_EXPIRATIONS: 'expirations',
        N_DOCUMENT: 'linked document',
        N_DOCUMENTS: 'linked documents',
        DELETED: 'Contract deleted.',
        DELETE_ERROR: 'Could not delete the contract. Please try again.',
      },
      FORM: {
        TITLE_NEW: 'New contract',
        TITLE_EDIT: 'Edit contract',
        TITLE_ADDENDA: 'Add addendum',
        SECTION_ADDENDA: 'Addendum details',
        ADDENDA_HINT: 'The addendum is an editable copy of this contract. Change what differs and save; the original contract is not modified.',
        ADDENDA_DATE: 'Addendum date',
        ADDENDA_DATE_REQUIRED: 'The addendum date is required.',
        DATE_INVALID: 'Invalid date. Use the DD/MM/YYYY format.',
        START_AFTER_END: 'The start of the term cannot be later than the contract expiration or termination date.',
        END_BEFORE_START: 'This date is earlier than the start of the term.',
        ADDENDA_COMMENT: 'Comment',
        ADDENDA_COMMENT_PLACEHOLDER: 'Briefly describe what changes in this addendum…',
        ADDENDA_COMMENT_REQUIRED: 'The addendum comment is required.',
        ADDENDA_CREATED: 'Addendum created.',
        SECTION_BASIC: 'Basic data',
        SECTION_PARTIES: 'Parties',
        SECTION_ECONOMICS: 'Economics',
        SECTION_RENEWAL: 'Renewal',
        SECTION_EXPIRATIONS: 'Additional expirations',
        SECTION_DOCUMENT: 'Document',
        SOCIETY: 'Company',
        SOCIETY_PLACEHOLDER: 'Select the contract company',
        SOCIETY_REQUIRED: 'Company is required.',
        SOCIETY_INVALID: 'The selected company is not valid.',
        NAME: 'Contract name',
        NAME_PLACEHOLDER: 'E.g. LATAM distribution framework agreement',
        NAME_REQUIRED: 'The contract name is required.',
        TYPE: 'Type',
        TYPE_PLACEHOLDER: 'Select a type',
        NO_TYPE: '— No type —',
        TAGS: 'Tags',
        TAGS_PLACEHOLDER: 'Type or select tags...',
        TAGS_HINT: 'Pick existing tags or type a new one and press Enter to create it.',
        SIGNATURE_DATE: 'Signature date',
        START_DATE: 'Effective start date',
        PARTY: 'Party',
        PARTY_PLACEHOLDER: 'Search person...',
        PARTY_HINT: 'Own entity or managed company.',
        PARTY_IS_SOCIETY: 'The party is the contract company',
        PARTY_IS_SOCIETY_HINT: 'The contract party is the linked company',
        KIND_PERSON: 'Person',
        KIND_SOCIETY: 'Company',
        COUNTERPARTY: 'Counterparty',
        COUNTERPARTY_PLACEHOLDER: 'Search the counterparty directory...',
        COUNTERPARTY_HINT: 'The directory is searched first to avoid duplicates. If it does not exist, you create it on the spot.',
        COUNTERPARTY_REQUIRED: 'The counterparty is required.',
        OBJECT: 'Object',
        OBJECT_PLACEHOLDER: 'Description of the contractual object...',
        MONTO: 'Amount',
        MONTO_HINT: '"Amount" replaces "Price".',
        CURRENCY: 'Currency',
        PERIODICITY: 'Periodicity',
        PERIODICITY_PLACEHOLDER: 'E.g. Quarterly, bimonthly…',
        PERIOD_MONTHLY: 'Monthly',
        PERIOD_BIMONTHLY: 'Bimonthly',
        PERIOD_QUARTERLY: 'Quarterly',
        PERIOD_FOURMONTHLY: 'Four-monthly',
        PERIOD_BIANNUAL: 'Biannual',
        PERIOD_ANNUAL: 'Annual',
        PERIOD_ONE_TIME: 'One-time',
        AUTO_RENEWAL: 'Auto renewal',
        NOTICE_PERIOD: 'Notice period (days)',
        TERM_DUE_DAY: 'Term due day',
        SECTION_CLASSIFICATION: 'Classification',
        SECTION_COUNTERPARTY: 'Counterparty',
        SECTION_AMOUNT: 'Amount and periodicity',
        SECTION_DATES: 'Dates and Conditions',
        PARENT_CONTRACT: 'Framework contract',
        PARENT_CONTRACT_PLACEHOLDER: 'Select a framework/master contract',
        PARENT_CONTRACT_NONE: '— No framework contract —',
        BELONGS_TO: 'Belongs to',
        PARENT_REQUIRED: 'A subcontract must belong to a framework/master contract.',
        PARENT_INVALID: 'The selected framework contract is not valid.',
        PARENT_NOT_ALLOWED: 'A framework/master contract cannot belong to another contract.',
        SOCIETIES: 'Brevity companies',
        ADD_SOCIETY: '+ Add company…',
        TERMINATION_DATE: 'Termination date',
        TERMINATION_NOTICE: 'Termination notice (days)',
        CP_NEW: 'New counterparty',
        CP_TYPE: 'Type',
        CP_CLIENT: 'Client',
        CP_PROVIDER: 'Provider',
        CP_EMPLOYEE: 'Employee',
        CP_PERSON: 'Person',
        CP_PHYSICAL: 'Individual',
        CP_LEGAL: 'Legal entity',
        CP_FIRST_NAME: 'First name',
        CP_LAST_NAME: 'Last name',
        CP_DNI: 'ID (optional)',
        CP_DNI_PLACEHOLDER: 'E.g. 30123456',
        CP_LEGAL_NAME: 'Legal name',
        CP_CUIT: 'Tax ID (optional)',
        CP_CUIT_PLACEHOLDER: 'E.g. 30-12345678-9',
        CP_CREATE_USE: 'Create and use',
        CP_REQUIRED: 'Complete the required counterparty fields.',
        CP_CREATED: 'Counterparty created.',
        CP_CREATE_ERROR: 'Could not create the counterparty. Please try again.',
        EXPIRATIONS_HINT: 'Price adjustments, technical reviews, payment milestones or other reminders tied to the contract.',
        EXP_LABEL: 'Label',
        EXP_LABEL_PLACEHOLDER: 'E.g. Price adjustment',
        EXP_DATE: 'Date',
        EXP_NOTICE: 'Notice (days)',
        ADD_EXPIRATION: 'Add expiration',
        PDF: 'Signed PDF file',
        PDF_PLACEHOLDER: 'Select PDF file',
        DOCUMENT: 'Linked document',
        LINK_DOCUMENT: 'Link document from library',
        LINK_DOCUMENT_HINT: 'Opens the company library to pick an existing document.',
        SAVE_BEFORE_LINK: 'Complete the required fields; the contract is saved before linking the document.',
        CREATED: 'Contract created.',
        UPDATED: 'Changes saved.',
        SAVE_ERROR: 'Could not save the contract. Please try again.',
        FILE_ERROR: 'The contract was saved, but the PDF upload failed.',
        TAG_CREATE_ERROR: 'Could not create the tag.',
        TAG_DELETE: 'Delete tag',
        TAG_DELETE_CONFIRM:
          'Delete this tag? It will be removed from the catalog and unlinked from all contracts.',
        TAG_DELETED: 'Tag deleted.',
        TAG_DELETE_ERROR: 'Could not delete the tag. Please try again.',
        TAG_DELETE_NOT_FOUND: 'The tag no longer exists.',
        TAG_DELETE_NOT_OWNER: 'You cannot delete a tag that is not your own.',
      },
      DETAIL: {
        BACK: 'Back to contracts',
        NOT_FOUND: 'Contract not found.',
        DOWNLOAD_PDF: 'Download PDF',
        OPEN_IN_NEW_TAB: 'Open in new tab',
        OWNER: 'Owner',
        NO_OWNER: '— unassigned —',
        OWNER_EDIT: 'Change owner',
        OWNER_PLACEHOLDER: 'Select an owner',
        OWNER_REQUIRED: 'Select an owner.',
        OWNER_UPDATED: 'Owner updated.',
        OWNER_INVALID: 'The selected user cannot be set as owner.',
        OWNER_ERROR: 'Could not update the owner. Please try again.',
        TAB_GENERAL: 'General information',
        TAB_EXPIRATIONS: 'Expirations',
        TAB_DOCUMENTS: 'Linked documents',
        TAB_HISTORY: 'History',
        SOCIETY: 'Associated company',
        NO_SOCIETY: '— not linked —',
        BELONGS_TO: 'Belongs to',
        PARENT_FALLBACK: 'Framework contract',
        SUBCONTRACTS: 'Subcontracts',
        NO_SUBCONTRACTS: 'This contract has no subcontracts.',
        NEW_SUBCONTRACT: 'New subcontract',
        ADD_ADDENDA: 'Add addendum',
        ADDENDAS: 'Addenda',
        OPEN_DOCUMENT: 'View document',
        EDIT_ADDENDA: 'Edit addendum',
        DELETE_ADDENDA: 'Delete addendum',
        ADDENDA_DELETE_CONFIRM: 'Delete this addendum? The fields it modified revert to their original value.',
        ADDENDA_DELETED: 'Addendum deleted.',
        ADDENDA_DELETE_ERROR: 'Could not delete the addendum. Please try again.',
        ADDENDA_UPDATED: 'Addendum updated.',
        MODIFIED_BY_ADDENDA: 'Modified by addendum #{{n}}',
        CURRENT_VALUE: 'Current state',
        NOTES: 'Notes',
        EXPIRATIONS_TITLE: 'Contract expirations',
        TERM_EXPIRATION: 'Term expiration',
        TERMINATION_DATE: 'Termination date',
        EXPIRATION_DATE: 'Expiration',
        NO_EXPIRATIONS: 'This contract has no registered expirations.',
        STATE_ACTION_REQUIRED: 'Action required',
        STATE_UPCOMING: 'Upcoming',
        STATE_SCHEDULED: 'Scheduled',
        STATE_FINAL: 'Final term',
        OVERDUE_DAYS: 'overdue by {{days}} days',
        IN_DAYS: 'in {{days}} days',
        DUE_TODAY: 'due today',
        EXP_REQUIRED: 'Fill in the label and date of the expiration.',
        EXP_LABEL_REQUIRED: 'The label is required.',
        EXP_DATE_REQUIRED: 'The date is required.',
        INCONSISTENT_DATES: 'Inconsistent dates',
        INCONSISTENT_DATES_HINT: 'The start of this contract term is later than its expiration or termination date. Review and fix the dates from Edit.',
        EXP_ADDED: 'Expiration added.',
        EXP_ERROR: 'Could not add the expiration. Please try again.',
        // DEVS-405 — concrete reasons returned by the dedicated expirations endpoint.
        EXP_ERROR_NOT_FOUND: 'Contract not found. It may have been deleted; please reload the page.',
        EXP_ERROR_INVALID_DATE: 'The expiration date is not valid.',
        EXP_ERROR_EXPIRATION_NOT_FOUND: 'Expiration not found. It may have been deleted; please reload the page.',
        MANAGE_DOCS: 'Manage documents',
        OPEN_LIBRARY: 'Open library',
        HAS_DOCS: 'This contract has linked documents.',
        NO_DOCS: 'This contract has no linked documents yet.',
        NO_FILES: 'No PDF available to download. Link a document from the library.',
        HISTORY_EMPTY: 'Change history is not available for contracts yet.',
      },
      HISTORY: {
        VIEW_CHANGES: 'Change log',
        VIEW_SECTIONS: 'Sections',
        VIEW_TIMELINE: 'Timeline',
        CURRENT_STATE: 'Current state',
        NO_STATE: 'There is no current-state data for this contract.',
        CHANGELOG: 'Change log',
        ADDENDAS: 'Addenda',
        ADDENDA_N: 'Addendum #{{n}}',
        OPEN_DOCUMENT: 'View document',
        DOCUMENT: 'Document',
        NO_FIELD_CHANGES: 'This addendum did not modify any field.',
        NO_ADDENDAS: 'This contract has no addenda.',
        NO_EVENTS: 'This contract has no events in its history.',
        EVENT_SIGNATURE: 'Contract signature',
        EVENT_ADDENDA: 'Addendum',
        EVENT_ADDENDA_N: 'Addendum #{{n}}',
        EVENT_EXPIRATION: 'Contract expiration',
        FIELD_MONTO: 'Amount',
        FIELD_PERIODICITY: 'Periodicity',
        FIELD_CURRENCY: 'Currency',
        FIELD_EXPIRATION: 'Expiration',
        FIELD_SIGNATURE: 'Signature date',
        FIELD_START: 'Start date',
        FIELD_TERMINATION: 'Termination date',
        FIELD_COUNTERPARTY: 'Counterparty',
        FIELD_SOCIETIES: 'Parties',
        FIELD_AUTO_RENEWAL: 'Auto renewal',
        FIELD_TERMINATION_NOTICE: 'Termination notice (days)',
      },
    },
    COUNTERPARTIES: {
      TITLE: 'Counterparties',
      BACK_TO_CONTRACTS: 'Back to contracts',
      BACK_TO_LIST: 'Back to counterparties',
      SEARCH_PLACEHOLDER: 'Search by name, legal name or document...',
      LOAD_NEW: 'New counterparty',
      COL_NAME: 'Name',
      COL_TYPE: 'Type',
      COL_PERSON_TYPE: 'Nature',
      COL_DOCUMENT: 'Document',
      COL_LINKED_CONTRACTS: 'Linked contracts',
      DELETE_HAS_CONTRACTS: 'Cannot delete: the counterparty has linked contracts.',
      TYPE_CLIENTE: 'Client',
      TYPE_PROVEEDOR: 'Provider',
      TYPE_EMPLEADO: 'Employee',
      PERSON_FISICA: 'Individual',
      PERSON_JURIDICA: 'Legal entity',
      NO_TYPE: '— no type —',
      NO_PERSON_TYPE: '— no nature —',
      REQUIRED: 'Complete the required counterparty fields.',
      CREATED: 'Counterparty created.',
      UPDATED: 'Changes saved.',
      SAVE_ERROR: 'Could not save the counterparty. Please try again.',
      LEGAL_NAME_REQUIRED: 'Legal name is required.',
      INVALID_TYPE: 'The selected type is not valid.',
      INVALID_PERSON_TYPE: 'The selected nature is not valid.',
      DELETE_CONFIRM: 'Are you sure you want to delete this counterparty?',
      DELETED: 'Counterparty deleted.',
      DELETE_ERROR: 'Could not delete the counterparty. Please try again.',
      FORM: {
        TITLE_NEW: 'New counterparty',
        TITLE_EDIT: 'Edit counterparty',
        SECTION_DATA: 'Counterparty details',
        TYPE: 'Type',
        PERSON_TYPE: 'Nature',
        FIRST_NAME: 'First name',
        LAST_NAME: 'Last name',
        DNI: 'ID (optional)',
        DNI_PLACEHOLDER: 'e.g. 30123456',
        LEGAL_NAME: 'Legal name',
        CUIT: 'Tax ID (optional)',
        CUIT_PLACEHOLDER: 'e.g. 30-12345678-9',
        DNI_SHORT: 'ID',
        CUIT_SHORT: 'Tax ID',
      },
      DETAIL: {
        LINKED_CONTRACTS: 'Linked contracts',
        NO_CONTRACTS: 'This counterparty has no linked contracts.',
        NOT_FOUND: 'Counterparty not found.',
      },
    },
    PROFILE: {
      LOGOUT: 'Log out',
      USERS_SETTINGS: 'Users settings',
    },
    ALERTS: {
      TAB_MY_CALENDAR: 'My calendar',
      TAB_EXPIRATIONS: 'Expirations',
      TAB_SETTINGS: 'Settings',
      SETTINGS: {
        TITLE: 'Alert settings by type',
        LEAD: 'Set how many days in advance you want to receive alerts for each expiration type. These advance notices apply to all your expirations, unless you customize a specific one from its own screen.',
        SYNC_NOTE: 'Changes will be reflected in your calendar at the next sync (Google Calendar may take up to 24h).',
        CHIPS_LABEL: 'Advance notice (days before expiration)',
        EMPTY_TYPE: 'No reminders for this type.',
        SUSTAINED_TOGGLE: 'Sustained reminder (last 5 days)',
        SUSTAINED_HINT: 'When active, you get a daily reminder during the last 5 days before the expiration.',
        TYPE_CONTRACT: 'Contracts',
        TYPE_POWER: 'Powers',
        TYPE_AUTHORITY: 'Authorities',
        TYPE_BALANCE: 'Balances',
        TYPE_CUSTOM: 'Custom alerts',
        SAVED: 'Settings saved.',
        ERROR_LOAD: 'Could not load settings.',
        ERROR_SAVE: 'Could not save settings. Please try again.',
      },
      ONBOARDING: {
        BANNER_TITLE: 'Bring your expirations to your calendar',
        BANNER_TEXT: 'Subscribe to the Brevity feed and get alerts in Google Calendar, Outlook or Apple Calendar.',
        BTN_SUBSCRIBE: 'Subscribe',
        BTN_SNOOZE: 'Remind me later',
        BTN_DISMISS: "Don't show again",
        MODAL_TITLE: 'Subscribe your calendar to the Brevity feed',
        MODAL_LEAD: 'Generate your personal URL and subscribe it in your calendar client. You will see every expiration as an all-day event.',
        MODAL_GENERATE_HINT: "You haven't generated your personal URL yet. Do it with one click — you can regenerate it any time from your profile.",
        MODAL_GENERATE_BUTTON: 'Generate my URL',
        TAB_GOOGLE: 'Google Calendar',
        TAB_OUTLOOK: 'Outlook',
        TAB_APPLE: 'Apple Calendar',
        STEP_GOOGLE_1: 'Open Google Calendar in your browser.',
        STEP_GOOGLE_2: 'In the left panel, click the "+" next to "Other calendars".',
        STEP_GOOGLE_3: 'Choose "From URL" and paste the URL you copied.',
        STEP_GOOGLE_4: 'Click "Add calendar". The expirations will appear in a few minutes.',
        STEP_OUTLOOK_1: 'Open Outlook web (outlook.live.com).',
        STEP_OUTLOOK_2: 'In the sidebar, click "Add calendar" → "Subscribe from web".',
        STEP_OUTLOOK_3: 'Paste the URL and give the calendar a name.',
        STEP_OUTLOOK_4: 'Confirm. Outlook syncs the feed automatically.',
        STEP_APPLE_1: 'In Apple Calendar, open the "File" menu.',
        STEP_APPLE_2: 'Choose "New calendar subscription" and paste the URL.',
        STEP_APPLE_3: 'Configure the refresh frequency and confirm.',
        SYNC_NOTE: 'Your calendar updates automatically, but changes may take up to 24h to appear. Google Calendar syncs feeds once a day.',
        SNACK_COPIED: 'URL copied to clipboard.',
        ERROR_GENERATE: 'Could not generate the URL. Please try again.',
        ERROR_GENERIC: 'Could not save the action. Please try again.',
      },
      LOADING: 'Loading…',
      EMPTY_TITLE: 'Subscribe your expirations to your calendar',
      EMPTY_DESCRIPTION: 'Generate a personal URL to subscribe your Brevity expirations in Google Calendar, Outlook or Apple Calendar. You will see each expiration as an all-day event, with a 20 and 10 days advance notice.',
      GENERATE_BUTTON: 'Generate my calendar URL',
      READY_TITLE: 'Your calendar is ready',
      READY_DESCRIPTION: 'Copy this URL and add it to your calendar client as "Subscribe from URL". You will see the expirations of the companies you have access to.',
      REGENERATE_BUTTON: 'Regenerate URL',
      SYNC_NOTE: 'Your calendar updates automatically, but changes may take up to 24 hours to appear. Google Calendar and Outlook sync subscribed feeds once a day — there is no way to force the update from Brevity.',
      HOW_TO_TITLE: 'How to subscribe in your calendar',
      HOWTO_GOOGLE: 'In Google Calendar: Settings → Add calendar → From URL → Paste the URL.',
      HOWTO_OUTLOOK: 'In Outlook web: Calendar → Add calendar → Subscribe from web → Paste the URL.',
      HOWTO_APPLE: 'In Apple Calendar: File → New calendar subscription → Paste the URL.',
      MODAL_REGENERATE_TITLE: 'Regenerate calendar URL',
      MODAL_REGENERATE_DESCRIPTION: 'If you regenerate, the previous URL will stop working. You will have to subscribe again in your calendar with the new URL. Continue?',
      SNACK_GENERATED: 'URL generated. Copy it and subscribe in your calendar.',
      SNACK_REGENERATED: 'URL regenerated. The previous one no longer works.',
      SNACK_COPIED: 'URL copied to clipboard',
      ERROR_LOAD: 'Could not load your calendar URL state.',
      ERROR_GENERIC: 'An error occurred. Please try again.',
    },
    MOVE_FOLDER: {
      TITLE: 'Move folder',
      CURRENT_LOCATION: 'Current location',
      CONFIRM_TITLE: 'Move folder?',
      CONFIRM_DESCRIPTION: 'You are about to move <b>{{name}}</b> to <b>{{destination}}</b>.',
      MOVING: 'Moving folder',
      SUCCESS: 'Folder moved',
      ERROR_TITLE: 'This operation cannot be performed',
      ERRORS: {
        name_conflict: 'A folder with that name already exists in the destination.',
        destination_inside_source: 'A folder cannot be moved into itself or one of its subfolders.',
        same_location: 'The folder is already in that location.',
        different_company: 'Folders can only be moved within the same company.',
        cannot_move_root: 'The company root folder cannot be moved.',
        destination_not_found: 'The folder no longer exists. Please refresh the view.',
        folder_not_found: 'The folder no longer exists. Please refresh the view.',
        forbidden: 'You do not have permission to move this folder.',
        technical_error: 'An error occurred and no changes were applied. Please try again.',
      },
    },
    TABLES: {
      EMPTY: 'No records to display',
    },
    TEXT: {
      YES: 'Yes',
      NO: 'No',
      ADV_SEARCH: 'Advanced Search',
      CHOOSE_COUNTRY_SIMPLE: "Select the company's country",
      CHOOSE_COMPANY: 'Select Company',
      CHOOSE_COUNTRY: "Select the company's country of origin",
      CHOOSE_COUNTRY_ALL: 'All countries',
      CHOOSE_ADMIN_GROUP: 'Select the administration group for the company',
      ADD_CUSTOM_EXPIRATION: 'Add custom expiration',
      EDIT_CUSTOM_EXPIRATION: 'Edit custom expiration',
      INVALID_SELECTION: 'Invalid selection',
      SURE_TO_DELETE: ' Are you sure you want to delete the expiration?',
      SURE_TO_DELETE_GROUP: 'Are you sure you want to remove this group?',
      SELECT_MODULE_ERROR: 'Select at least one section',
      POLITICALLY_EXPOSED: 'Politically exposed person',
      CHOOSE_DOC_TYPE: 'Select document type',
      CHOOSE_FOLDER_NAME: 'Select a folder',
      MOVE_FILE: 'Move File',
      MOVE_FILES: 'Move Files',
      NEW_FOLDER: 'New Forder',
      MOVE: 'Move',
      MOVE_HERE: 'Move Here',
      MOVING_FILES: 'Moving files',
      OF: 'of',
      RENAME_FOLDER: 'Rename Folder',
      NEW_FOLDER_NAME: 'New Folder Name',
      CHOOSE_FAC: "Select Facultaty",
      CHOOSE_IND: 'Select proxies',
      POWERS: 'Powers',
      IND: 'Proxies',
    },
    VALIDATION_MESSAGES: {
      MAX_PERM: "Max allowed is ",
      MAX_2: "Max length is 2",
      MAX_20: "Maximum number of characters is 20",
      MAX_30: "Max length is 30",
      MAX_40: "Maximum number of characters is 40",
      MAX_100: "Maximum number of characters is 100",
      MAX_150: "Maximum number of characters is 150",
      MAX_500: "Maximum number of characters is 500",
      MAX_10000: "Maximum number of characters is 10000",

      MAX_DIG_2: "Maximum allowed is 2 digits",
      MAX_DIG_30: "Maximum allowed is 30 digits",
      MAX_DIG_100: "Maximum allowed is 100 digits",

      MIN_DIG_0: "The minimum number is 0",
      MIN_NUM_1: "Minimum number is 1",
      MIN_0_0000000001: "Minimum number allowed is 0.0000000001",

      MAX_NUM_100: "Maximum number is 100",
      MAX_NUM_999: "Maximum number is 999",
      MAX_NUM_1000: "Maximum number is 1000",

      WHITE_SPACE: "You can't enter just white spaces",
      REQUIRED_FIELD: "Required field",
      SEL_FIR: "Select a signature",
      SEL_CAR: "Select a position",

      SOLO_NUM_GUION: "You can only enter numbers and hyphens",
      NUM_INV: "Invalid number",

      FEC_OTOR: "Grant date cannot be after expiration",
      FEC_EXP: "Expiration date cannot be before granting"
    },
    POA: {
      INDISTINCT: "Indistinct",
      INDIVIDUAL: "Individual",
      JOINT: "Joint"
    },
    // SETTING BY COUNTRY CODE
    BY_COUNTRY: {
      AR: {
        AUTHORITY: {
          REPRESENTATIVE: 'Appoint proxies',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'Document number',
          LEGAL_DOCUMENT_TYPE: 'CUIT',
          STREET: 'Address',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
          DEPARTMENT: 'Department details',
        },
        UBICATION: {
          POSTAL_CODE: 'Postal code',
          ADDRESS: 'Address',
          TYPE: 'Head office',
          FOREING: 'Local address',
          PROVINCE: 'Province',
          LOCATION: 'Locality',
          FIDEICOMISO_DOM: 'Address',
          FIDEICOMISO: 'Place of Trust',
          FOREING_ADDRESS: 'Foreing Address',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
          OFFICE_NUMBER: 'Office number',
        },
      },
      DF: {
        AUTHORITY: {
          REPRESENTATIVE: 'Appoint proxies',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'Document number',
          LEGAL_DOCUMENT_TYPE: 'CUIT',
          STREET: 'Address',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
          DEPARTMENT: 'Department details',
        },
        UBICATION: {
          POSTAL_CODE: 'Postal code',
          ADDRESS: 'Address',
          TYPE: 'Head office',
          FOREING: 'Local address',
          FOREING_ADDRESS: 'Principal place of business',
          PROVINCE: 'Province',
          LOCATION: 'Locality',
          FIDEICOMISO_DOM: 'Address',
          FIDEICOMISO: 'Place of Trust',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
          OFFICE_NUMBER: 'Office number',
        },
      },
      CL: {
        AUTHORITY: {
          REPRESENTATIVE: 'Appoint proxies',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'RUT',
          LEGAL_DOCUMENT_TYPE: 'RUT',
          STREET: 'Address',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
          DEPARTMENT: 'Department details',
        },
        UBICATION: {
          POSTAL_CODE: 'Postal code',
          ADDRESS: 'Address',
          TYPE: 'Head office',
          FOREING: 'Local address',
          PROVINCE: 'Province',
          LOCATION: 'Locality',
          FIDEICOMISO_DOM: 'Address',
          FIDEICOMISO: 'Place of Trust',
          FOREING_ADDRESS: 'Foreing address',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
          OFFICE_NUMBER: 'Office number',
        },
      },
      PY: {
        AUTHORITY: {
          REPRESENTATIVE: 'Appoint proxies',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'RUC',
          LEGAL_DOCUMENT_TYPE: 'RUC',
          STREET: 'Address',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
          DEPARTMENT: 'Department details',
        },
        UBICATION: {
          POSTAL_CODE: 'Postal code',
          ADDRESS: 'Address',
          TYPE: 'Head office',
          FOREING: 'Local address',
          PROVINCE: 'Province',
          LOCATION: 'Locality',
          FIDEICOMISO_DOM: 'Address',
          FIDEICOMISO: 'Place of Trust',
          FOREING_ADDRESS: 'Foreing address',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
          OFFICE_NUMBER: 'Office number',
        },
      },
      US: {
        INFO: {
          DOCUMENT_TYPE: 'TAX number',
          FILLING_NUMBER: 'Filling Number',
          REGISTERED_AGENT: 'Registered Agent',
        },
        AUTHORITY: {
          REPRESENTATIVE: 'Appoint proxies',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'ID Card',
          LEGAL_DOCUMENT_TYPE: 'ID Card',
          STREET: 'Street',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
        },
        UBICATION: {
          POSTAL_CODE: 'Postal code',
          ADDRESS: 'Address',
          TYPE: 'Principal place of business',
          FOREING_ADDRESS: 'Principal place of business',
          PROVINCE: 'Province',
          LOCATION: 'Location',
          FOREING: 'Local address',
          FIDEICOMISO_DOM: 'Address',
          FIDEICOMISO: 'Place of Trust',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
          OFFICE_NUMBER: 'Office number',
        },
      },
      UY: {
        AUTHORITY: {
          REPRESENTATIVE: 'Appoint proxies',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'RUT',
          LEGAL_DOCUMENT_TYPE: 'RUT',
          STREET: 'Address',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
          DEPARTMENT: 'Department details',
        },
        UBICATION: {
          POSTAL_CODE: 'Postal code',
          ADDRESS: 'Address',
          TYPE: 'Head office',
          FOREING: 'Local address',
          PROVINCE: 'Province',
          LOCATION: 'Locality',
          FIDEICOMISO_DOM: 'Address',
          FIDEICOMISO: 'Place of Trust',
          FOREING_ADDRESS: 'Foreing address',
          STREET: 'Street',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
          OFFICE_NUMBER: 'Office number',
          DOOR: 'Door number',
          APARTMENT: 'Apartment number',
        },
      },
      MX: {
        AUTHORITY: {
          REPRESENTATIVE: 'Appoint proxies',
        },
        INDIVIDUALS: {
          DOCUMENT_TYPE: 'RUT',
          LEGAL_DOCUMENT_TYPE: 'RUT',
          STREET: 'Address',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
          DEPARTMENT: 'Department details',
        },
        UBICATION: {
          POSTAL_CODE: 'Postal code',
          ADDRESS: 'Address',
          TYPE: 'Head office',
          FOREING: 'Local address',
          PROVINCE: 'Province',
          LOCATION: 'Locality',
          FIDEICOMISO_DOM: 'Address',
          FIDEICOMISO: 'Place of Trust',
          TAX_ADDRESS: 'Tax address',
          FOREING_ADDRESS: 'Foreing address',
          STREET: 'Street',
          FLOOR: 'Floor',
          ADDRESS_NUMBER: 'Number',
          OFFICE_NUMBER: 'Office number',
        },
      },
    },
    LOGS: {
      DATE_FROM: "Date from",
      DATE_TO: "Date to",
      USERS: "Users",
      DATE: "Date",
      EMAIL: "User",
      TYPE: "Type",
      DETAIL: "Details",
      DETAIL2: "Details",
      EXPORT: "Download"
    },
    USERS: {
      EXPORT: "Export CSV",
      SEARCH_PLACEHOLDER: "Search users"
    },
    MARITAL_STATUS: {
      CASADO: "Married",
      SOLTERO: "Single",
      DIVORCIADO: "Divorced",
      VIUDO: "Widow",
      UNION: "Coexistence Union"
    },
    PAGINATOR: {
      ITEMS_PER_PAGE: "Items per page",
      NEXT_PAGE: "Next page",
      PREVIOUS_PAGE: "Previous page",
      FIRST_PAGE: "First page",
      LAST_PAGE: "Last page",
      OF: "of"
    }
  }
};
